import contenteditableTypes from '../constants/contenteditable-types';

export default function isContenteditableRich(constraint) {
  return !!constraint.contenteditable && constraint.contenteditable === contenteditableTypes.RICH;
}
